import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import UndoIcon from "@mui/icons-material/Undo";
import Modal from "@mui/material/Modal";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import api from "../../api/api";
import { red, blue, green, purple } from "@mui/material/colors";
// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  Paper,
  useTheme,
  TableHead,
  TableCell,
  Table,
  TableRow,
  TableBody,
} from "@mui/material";
import { usertype_change } from "./StudentAssessmentQuiz.Slice";
import {
  getCommonQuizTopicThunk,
  createCommonQuizTopicThunk,
  updateCommonQuizTopicThunk,
  deleteCommonQuizTopicThunk,
} from "./StudentAssessmentQuiz.Thunk";
import { topic_change } from "../StudentAssessment/StudentAssessment.Slice";

const StudentAssessmentQuiz = () => {
  //
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [recordId, setRecordId] = useState("");
  const [selectedSkillsetId, setSelectedSkillsetId] = useState("");
  const [selectedSkillsetName, setSelectedSkillsetName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, _id, topicId, topicName, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setRecordId(_id);
    setSelectedSkillsetId(topicId);
    setSelectedSkillsetName(topicName);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
  };
  // ---------------------------------------------

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    navigate("/studentassessment");
  };
  // ------------------------------------------------------------

  // --------- options for dropdowns ---------
  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
  ];

  const program_select_option_list = [
    { value: "ece", text: "ECE" },
    { value: "pge", text: "PGE" },
  ];

  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  const ece_select_option_list = [
    { value: 1, text: "1" },
    { value: 2, text: "2" },
    { value: 3, text: "3" },
  ];

  const pge_select_option_list = [
    { value: 1, text: "1" },
    { value: 2, text: "2" },
    { value: 3, text: "3" },
    { value: 4, text: "4" },
    { value: 5, text: "5" },
  ];

  const validity_select_option_list = [
    { value: "limited", text: "Limited" },
    { value: "unlimited", text: "Unlimited" },
  ];
  const [language, setLanguage] = useState("od");
  // ------------ dropdowns on change ----------------

  const language_select_onchange = (e) => {
    if (!e.target.value) {
      setLanguage("");
      setUsertype("");
      setProgram("");
      setClas("");
    } else {
      setLanguage(e.target.value);
      setUsertype("");
      setProgram("");
      setClas("");
    }
  };

  const usertype_select_onchange = (event) => {
    setUsertype(event.target.value); // Update the usertype state with the selected value
    if (!event.target.value) {
      setProgram("");
      setClas("");
    } else {
      setProgram("");
      setClas("");
    }
  };

  const data = useSelector((state) => state.StudentAssessmentQuizSlice.topic);

  // ------------ Load data & skill ----------------

  const topicId = useSelector(
    (state) => state.StudentAssessmentQuizSlice.topicId
  );

  const topicName = useSelector(
    (state) => state.StudentAssessmentQuizSlice.topicName
  );

  // const usertype = useSelector(
  //   (state) => state.StudentAssessmentQuizSlice.usertype
  // );
  const [usertype, setUsertype] = useState("fellow");

  const validityType = useSelector(
    (state) => state.StudentAssessmentQuizSlice.validityType
  );

  const disable_content_button = useSelector(
    (state) => state.StudentAssessmentQuizSlice.disable_content_button
  );

  // -----------------------------------------------

  // For State Declaration
  const [show, setShow] = useState(false);

  //On Modal close and open

  const handleClose = () => setShow(false);
  const handleShow = () => {
    if (language && usertype && program && clas) {
      setShow(true);
    } else {
      toast.error("Please first select all the fields !");
    }
  };

  const [showUpdate, setShowUpdate] = useState(false);

  const [changetopicName, setChangetopicName] = useState("");
  const handleChangetopicName = (event) => {
    setChangetopicName(event.target.value);
  };
  const [changevalidity, setChangevalidity] = useState(0);
  const handleChangevalidity = (event) => {
    setChangevalidity(event.target.value);
  };
  const [changevaliditytype, setChangevaliditytype] = useState("");
  const handleChangevaliditytype = (event) => {
    setChangevaliditytype(event.target.value);
  };

  //----Program type selection and handling----------
  const [program, setProgram] = useState("");
  const [clas, setClas] = useState("");

  const program_select_onchange = (event) => {
    if (!event.target.value) {
      setProgram("");
      setClas("");
    } else {
      setProgram(event.target.value);
      setClas("");
      const data = {
        usertype: usertype,
        program: event.target.value,
        clas: parseInt(clas),
      };
      if (clas) {
        dispatch(getCommonQuizTopicThunk(data));
      } else {
        dispatch(getCommonQuizTopicThunk(""));
      }
    }
  };

  //---------Class type selection and handling-----------
  const clas_select_onchange = (event) => {
    if (!event.target.value) {
      // setClas("");
      dispatch(topic_change(""));
      dispatch(getCommonQuizTopicThunk(""));
    } else {
      setClas(event.target.value);
      const data = {
        usertype: usertype,
        program: program,
        clas: event.target.value,
      };
      dispatch(getCommonQuizTopicThunk(data));
    }
  };

  //console.log("clas------------------>", clas);
  //console.log("program-------------->", program);
  //console.log("data----------------->", data);

  // useEffect(() => {
  //   const data = {
  //     usertype: usertype,
  //     program: program,
  //     class: clas,
  //   };
  //   if (usertype && program && language && clas) {
  //     dispatch(getCommonQuizTopicThunk(data));
  //   }
  // }, [clas]);

  // ----------- create, update delete button click ----------
  const [isLoading, setIsLoading] = useState(false);
  const dataa = {
    topicId: new Date().getTime(),
    topicName: changetopicName,
    validity: parseInt(changevalidity),
    language: "od",
    usertype: usertype,
    validityType: changevaliditytype,
    module: "student",
    class: parseInt(clas),
    program: program,
  };
  const handleSave = () => {
    //console.log("validity type----------->", typeof changevalidity);
    //console.log("validity type sent----------->", typeof changevaliditytype);

    setShow(false);
    setIsLoading(true);
    toast.success("Changes made successfully");
    dispatch(createCommonQuizTopicThunk(dataa))
      .then((res) => {
        const data = {
          usertype: usertype,
          program: program,
          clas: parseInt(clas),
        };
        dispatch(getCommonQuizTopicThunk(data));
      })
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  const [updateData, setUpdateData] = useState({
    questionId: new Date().getTime(),
    topicId: topicId,
    topicName: "",
    validity: "",
    validityType: "",
    usertype: usertype,
    language: language,
  });
  //console.log("updateData-->", updateData);

  const [updateExtra, setUpdateExtra] = useState([]);
  const handleShowUpdate = (eachskill) => {
    setUpdateExtra(eachskill);
    setUpdateData({
      topicId: eachskill.topicId,
      questionId: eachskill.questionId,
      topicName: eachskill.topicName,
      validity: eachskill.validity,
      validityType: eachskill.validityType,

      usertype: usertype,
    }); //
    //console.log("updateData----------->", updateData);
    setShowUpdate(true);
  };
  const handleUpdateChanges = () => {
    api
      .put(`updateMasterTtlQuizTopic`, updateData)
      .then(
        //
        //
        (response) => {
          if (response && response.status === 200) {
            const data = {
              usertype: usertype,
              program: program,
              clas: parseInt(clas),
            };
            toast.success("Changes made successfully");
            dispatch(getCommonQuizTopicThunk(data));
          }
          // }
        },
        (err) => {
          //console.log(err);
          toast.error("Enter a valid Topic");
        }
      )
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
    setShowUpdate(false);
  };
  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  //!  For deleting the quiz topic in the StudentAssessmentQuiz page--------------------------------
  const delete_content_button_click = (questionId) => {
    //console.log("topicId-->", topicId);
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteCommonQuizTopicThunk(questionId))
          .then((res) => {
            const data = {
              usertype: usertype,
              program: program,
              clas: parseInt(clas),
            };
            dispatch(getCommonQuizTopicThunk(data));
            toast.success("Changes made successfully");
          })
          .catch((error) => {
            console.error("The error is--------------->", error);
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
          });
      }
    });
  };

  return (
    <>
      <div>
        <MuiHeader header="Student Assessment Quiz" />

        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={language}
            label="Language"
            onChange={language_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype} // Use the usertype state as the value
            label="Usertype"
            onChange={usertype_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language &&
              usertype_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        {usertype ? (
          <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
            <InputLabel id="demo-select-small">Program</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={program} //
              label="Program"
              onChange={program_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {usertype &&
                program_select_option_list.map(
                  (
                    option //
                  ) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  )
                )}
            </Select>
          </FormControl>
        ) : null}
        {program === "ece" ? (
          <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
            <InputLabel id="demo-select-small">Level</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={clas}
              label="Level"
              onChange={clas_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {usertype &&
                program &&
                ece_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        ) : program === "pge" ? (
          <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
            <InputLabel id="demo-select-small">Class</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={clas} //
              label="Class"
              onChange={clas_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {usertype &&
                program &&
                pge_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        ) : null}
        <Button
          onClick={navigate_to}
          variant="outlined"
          sx={{
            minWidth: 80,
            alignItem: "right",
            backgroundColor: "blue",
            color: "black",
          }}
          size="small"
        >
          <UndoIcon style={{ color: "orange" }}></UndoIcon>
          Back
        </Button>
      </div>

      {/* Show List */}
      <div>
        <div>
          <Button
            onClick={handleShow}
            variant="contained"
            sx={{ marginTop: 3, float: "left" }}
            // disabled={disable_content_button}
          >
            create new topic
            {/* <AddIcon /> */}
          </Button>
          <br />
          <br />
          <br />

          <Modal
            open={show}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <br />
              <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={3} style={{ marginTop: 12 }}>
                    <Grid style={{ width: "125px" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginTop: "14px" }}
                      >
                        validity type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{
                          marginLeft: "20px",
                          width: "224px",
                          paddingTop: "10px",
                        }}
                        label="validity type"
                        onChange={handleChangevaliditytype}
                      >
                        <MenuItem value="">None</MenuItem>
                        <MenuItem value="limited">Limited</MenuItem>
                        <MenuItem value="unlimited">Unlimited</MenuItem>
                      </Select>
                    </Grid>

                    {changevaliditytype !== "" &&
                      changevaliditytype !== "unlimited" && (
                        <Grid item xs={9} md={9}>
                          <TextField
                            id="outlined-basic"
                            label="validity"
                            variant="outlined"
                            onChange={handleChangevalidity} // //
                          />
                        </Grid>
                      )}

                    <Grid item xs={9} md={9}>
                      <TextField
                        id="outlined-basic"
                        label="topic"
                        variant="outlined"
                        onChange={handleChangetopicName}
                      />
                    </Grid>
                    {/* {validityType === "limited" ? ( */}

                    {/* ) : null }  */}
                  </Grid>
                </Box>
              </FormControl>
              <Button
                variant="outlined"
                style={{ marginLeft: 12 }}
                onClick={handleClose}
              >
                Close
              </Button>
              <Button variant="contained" onClick={handleSave}>
                Save
              </Button>
            </Box>
          </Modal>
        </div>
        <br />
        {language && usertype && program && clas && data && data.length > 0 ? (
          <Paper style={{ width: 700 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: "60px" }}> Order</TableCell>
                  <TableCell style={{ width: "210px", paddingLeft: "30px" }}>
                    {" "}
                    Topic
                  </TableCell>
                  <TableCell style={{ width: "170px", paddingLeft: "80px" }}>
                    {" "}
                    Validity Type
                  </TableCell>
                  <TableCell style={{ width: "120px", paddingLeft: "80px" }}>
                    {" "}
                    Validity
                  </TableCell>
                  <TableCell style={{ paddingLeft: "120px" }}>
                    {" "}
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              {data.map((eachskill, index) => (
                <TableBody key={index}>
                  <TableRow>
                    <TableCell style={{ width: "100px" }}>
                      {index + 1}
                    </TableCell>
                    <TableCell style={{ width: "180px", paddingLeft: "30px" }}>
                      {eachskill.topicName}
                    </TableCell>{" "}
                    <TableCell style={{ width: "100px", paddingLeft: "80px" }}>
                      {eachskill.validityType}
                    </TableCell>{" "}
                    <TableCell style={{ width: "100px", paddingLeft: "95px" }}>
                      {" "}
                      {eachskill.validityType === "unlimited"
                        ? "NA"
                        : eachskill.validity}
                    </TableCell>
                    <TableCell
                      style={{
                        width: -20,
                        paddingLeft: "-130px",
                        marginLeft: "-120px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          style={{ marginLeft: 65 }}
                          onClick={() => handleShowUpdate(eachskill)}
                        >
                          <EditIcon style={{ color: "blue" }}></EditIcon>
                        </Button>
                        <Button
                          onClick={() => delete_content_button_click(eachskill)}
                        >
                          <DeleteIcon style={{ color: "red" }}></DeleteIcon>
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ))}
            </Table>
          </Paper>
        ) : null}

        <Modal
          open={showUpdate}
          onClose={handleCloseUpdate}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2} style={{ marginTop: 1 }}>
                  <Grid item xs={6} md={6}>
                    <Select
                      id="outlined-basic"
                      style={{ width: "140px" }}
                      label="validity type"
                      variant="outlined"
                      value={updateData.validityType}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          validityType: e.target.value,
                        })
                      }
                    >
                      <MenuItem value="">None</MenuItem>
                      <MenuItem value="limited">Limited</MenuItem>
                      <MenuItem value="unlimited">Unlimited</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Topic"
                      variant="outlined"
                      value={updateData.topicName}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          topicName: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  {updateData.validityType === "limited" ? (
                    <Grid item xs={6} md={6}>
                      <TextField
                        id="outlined-basic"
                        label="Validity"
                        variant="outlined"
                        value={updateData.validity}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            validity: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  ) : null}
                </Grid>
              </Box>
            </FormControl>

            <Button
              variant="outlined"
              style={{ marginLeft: 12, marginTop: 30 }}
              onClick={handleCloseUpdate}
            >
              Close
            </Button>
            <Button
              variant="contained"
              style={{ marginLeft: 12, marginTop: 30 }}
              onClick={handleUpdateChanges}
            >
              Update
            </Button>
          </Box>
        </Modal>
      </div>
      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default StudentAssessmentQuiz;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
